import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "EventToolTestRideRegistrationDialog" })
export default class EventToolTestRideRegistrationDialog extends Vue {
    public localizer: any = Localizer;

    @Prop() readonly eventIdMaster: string;
    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly registrationToken: string;
    @Prop() readonly email: string;
    @Prop() readonly page: string;
    @Prop() readonly isBackend: boolean;

    get isRegistrationVisible() {
        return this.$store.getters["eventToolStore/isRegistrationVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isRegistrationVisible") async onChangeOwnerVisibleUpdate(newValue: boolean) {
        if (newValue) {
            document.body.classList.add("overflow");
            (<any>this).$refs.ownerRegistrationModel.classList.add("show");
            document.querySelector("#RegistrationModel").scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.ownerRegistrationModel.classList.remove("show");
        }
    }

    public closeDialog() {
        this.$store.commit("eventToolStore/setIsRegistrationVisible", false);
    }
}